import { render, staticRenderFns } from "./MenuPartner.vue?vue&type=template&id=b3bcb1ca&scoped=true&"
import script from "./MenuPartner.vue?vue&type=script&lang=js&"
export * from "./MenuPartner.vue?vue&type=script&lang=js&"
import style0 from "./MenuPartner.vue?vue&type=style&index=0&id=b3bcb1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bcb1ca",
  null
  
)

export default component.exports